import PropTypes from "prop-types";
import React from "react";
import { Modal } from "react-bootstrap";
import Loading from "./Loading";

export default function LoadingModel({ show = false }) {
    return (
        <Modal show={show} keyboard={false} dialogClassName="modal-50w" size="sm" centered>
            <Modal.Body
                style={{
                    height: 150,
                    color:"#3e3e3e",
                    zIndex: 1051
                }}
                className="d-flex align-items-center justify-content-center"
            >
                <Loading/>
            </Modal.Body>
        </Modal>
    );
}
LoadingModel.propTypes = {
    show: PropTypes.bool,
};
